import { render } from "./Textarea.vue?vue&type=template&id=0eee9705&scoped=true&ts=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"

import "./Textarea.vue?vue&type=style&index=0&id=0eee9705&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eee9705"]])

export default __exports__